import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import AdminLayout from '../admin-panal/AdminLayout.tsx';
import AdminLogin from '../admin-panal/AdminLogin.tsx';
import Dashboard from '../admin-panal/pages/Dashboard.tsx';
import MandiBhavVideos from '../admin-panal/pages/MandiBhavVideos.tsx';
import BubbleVideos from '../admin-panal/pages/BubbleVideos.tsx';
import NewsSection from '../admin-panal/pages/NewsSection.tsx';
import TrendingNews from '../admin-panal/pages/TrendingNews.tsx';
import GovernmentSchemes from '../admin-panal/pages/GovernmentSchemes.tsx';
import CropPriceTable from '../admin-panal/pages/CropPriceTable.tsx';
import CropsSection from '../admin-panal/pages/CropsSection.tsx';
import VolumeSection from '../admin-panal/pages/VolumeSection.tsx';
import Users from '../admin-panal/pages/Users.tsx';
import Notifications from '../admin-panal/pages/Notifications.tsx';
import Settings from '../admin-panal/pages/Settings.tsx';
import MarketConditions from '../admin-panal/pages/MarketConditions.tsx';

const AdminPanelWrapper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check authentication status on component mount
  useEffect(() => {
    const checkAuth = () => {
      const authStatus = localStorage.getItem('admin_authenticated');
      const adminEmail = localStorage.getItem('admin_email');
      const loginTime = localStorage.getItem('admin_login_time');
      
      // Check if user is authenticated and login is not expired (24 hours)
      if (authStatus === 'true' && adminEmail && loginTime) {
        const loginDate = new Date(loginTime);
        const now = new Date();
        const hoursDiff = (now - loginDate) / (1000 * 60 * 60);
        
        if (hoursDiff < 24) { // Session valid for 24 hours
          setIsAuthenticated(true);
        } else {
          // Session expired, clear localStorage
          localStorage.removeItem('admin_authenticated');
          localStorage.removeItem('admin_email');
          localStorage.removeItem('admin_login_time');
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
      
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  // Handle successful login
  const handleLogin = (success) => {
    if (success) {
      setIsAuthenticated(true);
      // Navigate to dashboard after successful login
      navigate('/admin-panal/dashboard');
    }
  };

  // Handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
    navigate('/admin-panal');
  };

  // Get current page from pathname, removing /admin-panal prefix
  const getCurrentPage = () => {
    const path = location.pathname.replace('/admin-panal', '').replace('/', '') || 'dashboard';
    return path;
  };

  // Handle page navigation with admin-panal prefix
  const handlePageChange = (page) => {
    navigate(`/admin-panal/${page === 'dashboard' ? '' : page}`);
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return <AdminLogin onLogin={handleLogin} />;
  }

  // Show admin panel if authenticated
  return (
    <AdminLayout 
      currentPage={getCurrentPage()} 
      onPageChange={handlePageChange}
      onLogout={handleLogout}
    >
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mandi-bhav-videos" element={<MandiBhavVideos />} />
        <Route path="/bubble-videos" element={<BubbleVideos />} />
        <Route path="/news-section" element={<NewsSection />} />
        <Route path="/trending-news" element={<TrendingNews />} />
        <Route path="/government-schemes" element={<GovernmentSchemes />} />
        <Route path="/crop-price-table" element={<CropPriceTable />} />
        <Route path="/crops" element={<CropsSection />} />
        <Route path="/volumes" element={<VolumeSection />} />
        <Route path="/users" element={<Users />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/market-conditions" element={<MarketConditions />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminPanelWrapper;
